import PropTypes from 'prop-types'

const rolePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
})

export default rolePropType
